import { css } from '@emotion/react';
import { fontFallback } from '@atlaskit/theme/typography';
export const commonTextStyles = css({
  font: `var(--ds-font-body, ${fontFallback.body.medium})`,
  wordBreak: 'break-word'
});